import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from '../config/api';
import { setBaristaProfile, setBaristaToken } from '../utils/authStorage';
import { FaCoffee, FaSpinner } from 'react-icons/fa';

export default function BaristaLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from =
    (location.state as { from?: { pathname?: string } } | null)?.from?.pathname || '/barista';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/barista/login', { email, password });
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
      await setBaristaToken(data.token);
      await setBaristaProfile(data.barista);
      const safe =
        from && from.startsWith('/barista') && !from.startsWith('/barista/login')
          ? from
          : '/barista';
      navigate(safe, { replace: true });
    } catch (err: any) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        (err.code === 'ERR_NETWORK' ? 'Network error — check your connection.' : 'Sign-in failed.');
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#ebe3d6] px-4">
      <div className="bg-white p-8 rounded-xl shadow-xl w-full max-w-md border border-[#d4c4b0]">
        <div className="text-center mb-6">
          <FaCoffee className="text-5xl text-amber-800 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#2f2823]">Staff console</h1>
          <p className="text-sm text-[#5c534c] mt-1">Sign in with your cafe staff account</p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-800 text-sm p-3 rounded-lg mb-4 border border-red-200">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#2f2823] mb-1">Work email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-[#c4b5a4] rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-amber-600"
              required
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2f2823] mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-[#c4b5a4] rounded-lg focus:ring-2 focus:ring-amber-600 focus:border-amber-600"
              required
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-amber-800 hover:bg-amber-900 text-white font-semibold disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <FaSpinner className="animate-spin" />
                Signing in…
              </>
            ) : (
              'Sign in'
            )}
          </button>
        </form>

        <p className="text-center text-sm text-[#5c534c] mt-6">
          <Link to="/login" className="text-amber-800 font-medium hover:underline">
            Customer app login
          </Link>
        </p>
      </div>
    </div>
  );
}
